// extracted by mini-css-extract-plugin
module.exports = {"lineFend":"Index_lineFend__2IE3I","lineAnimation":"Index_lineAnimation__3x9cr","normal":"Index_normal__3O1sE","animationFade":"Index_animationFade__3bycJ"};